'use client';

import { Loader2 } from 'lucide-react';

export function DetailsArbreLoader() {
  return (
    <div
      className="flex min-h-screen items-center justify-center bg-background antialiased"
      role="status"
      aria-live="polite"
    >
      <div className="flex flex-col items-center gap-4">
        <div className="relative">
          <Loader2 className="h-10 w-10 animate-spin text-primary" aria-hidden="true" />
          <div className="absolute inset-0 h-10 w-10 animate-ping rounded-full bg-primary/20" aria-hidden="true" />
        </div>
        <p className="text-base font-semibold text-muted-foreground">Chargement des données...</p>
      </div>
    </div>
  );
}

